import envConfig from "@/config/envConfig";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const mainApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: envConfig.API_URL_BASED + "/api/",
    // prepareHeaders: async (headers, { getState }) => {
    //   const token = await (getState()).auth.token;
    //   const language = localStorage.getItem("i18nextLng") || "en";
    //   if (token) headers.set("Authorization", token);
    //   headers.set("Accept-Language", language);
    //   return headers;
    // },
    credentials: "include",
  }),
  tagTypes: ["Dashboard", "DashboardChart", "DashboardDial", "LiveDashboard", "DeviceParameter"],
  endpoints: (builder) => ({
    uploadFile: builder.mutation({
      query: (formData) => ({
        url: "v2/file-upload",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useUploadFileMutation } = mainApi;
